
import { KYMW6801Model } from '../kymw6801.model';
import { KYMW6800commonModel } from '../../kymw6800/vo/kymw6800-common.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * CWSカテゴリ変換マスタ情報を登録する
 *
 * @export API通信成功時の処理
 * @class RegistCategoryConvInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistCategoryConvInfoService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW6801Model;
  private successFunc: Function;
  private vo: KYMW6800commonModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistCategoryConvInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CategoryDiv: this.vo.categoryDiv,
        ConvDiv: this.vo.convDiv,
        CategoryCode: this.vo.categoryCode,
        ClassCode: this.vo.classCode === undefined ? null : this.vo.classCode,
        LargeClassCode: this.vo.largeClassCode,
        MiddleClassCode: this.vo.middleClassCode,
        SmallClassCode: this.vo.smallClassCode,
        MarkCode1: this.vo.markCode1,
        MarkCode2: this.vo.markCode2,
        MarkCode3: this.vo.markCode3,
        PricePattern: this.vo.pricePattern,
        MediumType: this.vo.mediumType,
        FeatureCode: this.vo.featureCode,
        PageNum: this.vo.pageNum,
        PromotionDiv: this.vo.promotionDiv,
        PromotionInfo: this.vo.promotionInfo,
        ExhibitionDiv: this.vo.exhibitionDiv,
        Tag1: this.vo.tag1,
        Tag2: this.vo.tag2,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW6801Model} model
   * @param {string} orderCode
   * @param {string} categoryLevel
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof RegistCategoryConvInfoService
   */
  execute(model: KYMW6801Model, vo: KYMW6800commonModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('registCategoryConvInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistCategoryConvInfoService
   */
  success(data: any) {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
